import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API, fmtTgl, pesanGalat } from "../lib/api";
import Shell from "../components/Shell";
import { JudulHalaman, KerangkaBaris, KeadaanGalat, KeadaanKosong, KELAS_TABEL, KELAS_TH, KELAS_TD } from "../components/kit";

export default function Sistem() {
  const [rows, setRows] = useState(null);
  const [pengguna, setPengguna] = useState([]);
  const [info, setInfo] = useState(null);
  const [galat, setGalat] = useState(null);
  const [f, setF] = useState({ label: "", kategori: "", pemilik_id: "", cara_ekspor: "CSV" });
  const [tampilForm, setTampilForm] = useState(false);

  const muat = () => {
    setGalat(null);
    API.get("/sistem").then((r) => setRows(r.data)).catch((e) => setGalat(pesanGalat(e)));
    API.get("/pengguna").then((r) => setPengguna(r.data.filter((p) => p.peran === "pemilik"))).catch(() => {});
    API.get("/perusahaan/saya").then((r) => setInfo(r.data)).catch(() => {});
  };
  useEffect(muat, []);

  const tambah = async (e) => {
    e.preventDefault();
    try {
      await API.post("/sistem", { ...f, pemilik_id: f.pemilik_id || null });
      setF({ label: "", kategori: "", pemilik_id: "", cara_ekspor: "CSV" });
      setTampilForm(false);
      muat();
    } catch (err) { alert(pesanGalat(err)); }
  };

  return (
    <Shell>
      <JudulHalaman testid="judul-sistem" judul="Daftar Akses"
        sub="Daftar akses yang dipakai di perusahaan Anda. Hanya Admin IT yang bisa menambahkannya." />
      {info && (
        <div className="panel rounded p-5 mb-6" data-testid="panel-formulir-publik">
          <p className="label-kecil">Formulir umum</p>
          <p className="mt-3 text-sm">
            Pengaturan formulir umum, undangan rekan, dan lencana verifikasi kini ada di layar{" "}
            <Link to="/ruang-kerja" data-testid="tautan-ruang-kerja" className="underline text-primary">Ruang Kerja</Link>.
          </p>
        </div>
      )}
      <div className="mb-4">
        <button data-testid="btn-tambah-sistem" onClick={() => setTampilForm(!tampilForm)}
          className="tombol-utama px-4 py-2.5 rounded text-sm">
          {tampilForm ? "Batal" : "Tambah akses"}
        </button>
      </div>
      {tampilForm && (
        <form onSubmit={tambah} className="panel rounded p-5 mb-6 grid md:grid-cols-4 gap-4" data-testid="form-sistem">
          <div>
            <label className="text-xs font-medium uppercase tracking-wide" htmlFor="s-label">Label generik</label>
            <input id="s-label" data-testid="input-label-sistem" required value={f.label}
              onChange={(e) => setF({ ...f, label: e.target.value })} placeholder='cth. "Akses H — Gudang Berkas"'
              className="mt-1 w-full border bg-background px-2 py-1.5 text-sm" />
          </div>
          <div>
            <label className="text-xs font-medium uppercase tracking-wide" htmlFor="s-kategori">Kategori</label>
            <input id="s-kategori" data-testid="input-kategori-sistem" required value={f.kategori}
              onChange={(e) => setF({ ...f, kategori: e.target.value })} className="mt-1 w-full border bg-background px-2 py-1.5 text-sm" />
          </div>
          <div>
            <label className="text-xs font-medium uppercase tracking-wide" htmlFor="s-pemilik">Pemilik akses</label>
            <select id="s-pemilik" data-testid="pilih-pemilik-sistem" value={f.pemilik_id}
              onChange={(e) => setF({ ...f, pemilik_id: e.target.value })} className="mt-1 w-full border bg-background px-2 py-1.5 text-sm">
              <option value="">— belum ada pemilik —</option>
              {pengguna.map((p) => <option key={p.id} value={p.id}>{p.nama}</option>)}
            </select>
          </div>
          <div>
            <label className="text-xs font-medium uppercase tracking-wide" htmlFor="s-ekspor">Cara ekspor</label>
            <input id="s-ekspor" data-testid="input-cara-ekspor" value={f.cara_ekspor}
              onChange={(e) => setF({ ...f, cara_ekspor: e.target.value })} className="mt-1 w-full border bg-background px-2 py-1.5 text-sm" />
          </div>
          <div className="md:col-span-4">
            <button data-testid="btn-simpan-sistem" className="px-4 py-2 bg-primary text-primary-foreground text-sm font-medium">Simpan</button>
          </div>
        </form>
      )}
      {galat && <KeadaanGalat testid="galat-sistem" pesan={galat} onCoba={muat} />}
      {!rows && !galat && <KerangkaBaris testid="memuat-sistem" n={4} />}
      {rows && rows.length === 0 && <KeadaanKosong testid="kosong-sistem" teks="Belum ada akses yang tercatat." aksiLabel="Tambah akses" onAksi={() => setTampilForm(true)} />}
      {rows && rows.length > 0 && (
        <div className="overflow-x-auto border">
          <table className={KELAS_TABEL} data-testid="tabel-sistem">
            <thead>
              <tr>
                <th className={KELAS_TH}>Label</th><th className={KELAS_TH}>Kategori</th>
                <th className={KELAS_TH}>Pemilik</th><th className={KELAS_TH}>Cara mengambil data</th><th className={KELAS_TH}>Terakhir diperiksa</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((s) => (
                <tr key={s.id} data-testid={`sistem-${s.id}`}>
                  <td className={`${KELAS_TD} font-medium`}>{s.label}</td>
                  <td className={KELAS_TD}>{s.kategori}</td>
                  <td className={KELAS_TD}>
                    {s.pemilik_nama || <span className="text-red-600 dark:text-red-400 text-xs font-medium">belum ada</span>}
                  </td>
                  <td className={`${KELAS_TD} font-data text-xs`}>{s.cara_ekspor}</td>
                  <td className={`${KELAS_TD} font-data text-xs`}>{fmtTgl(s.terakhir_disapu)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Shell>
  );
}
